import Vue from 'vue';
import axios from 'axios';

import store from '../store';
import types from '../store/mutation-types';

function toastError(errorMessage) {
  if (!Vue || !Vue.prototype.$element || !Vue.prototype.$element.message) return;
  Vue.prototype.$element.message.error(errorMessage);
}

const axiosInstance = axios.create({});

axiosInstance.interceptors.request.use((request) => {
  store.dispatch(types.LOAD_START);
  return request;
});

axiosInstance.interceptors.response.use((response) => {
  store.dispatch(types.LOAD_END);
  if (response.data.retcode === 0 && response.data.error_no === 0) {
    return response;
  }
  if (response.status !== 200) {
    return Promise.reject(response.data);
  }
  if (response.data.error_no !== 200 && response.data.error_no !== 0) { // event-report接口成功后这个error_no是返回0的且不能改 此时不应toast ;
    toastError(response.data.error_msg || response.data);
    return Promise.reject(response.data);
  }

  return response;
}, (error) => {
  store.dispatch(types.LOAD_END);
  if (error.response.status === 401) {
    const matches = (/^(?:https?:\/\/[^/]*?)((?:\/[^/]+)+)/g).exec(window.location.href);
    if (matches.length > 1) {
      window.location.href = `/login?redirect=${matches[1]}`;
      return Promise.reject(error.response.data);
    }
    window.location.href = '/login';
    return Promise.reject(error.response.data);
  }
  if (error.response.status === 403) {
    window.location.href = '/404';
    return null;
  }
  toastError(error.response.data.error_msg || error.response.data);
  return Promise.reject(error);
});

export default axiosInstance;

export function fetchFileToken(filename) {
  return axiosInstance({
    method: 'get',
    url: `/admin/ar/sts/token?filename=${filename}`,
  });
}
